import styles from './active-users.module.scss';
import { Box, Container } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';
import { useGetRequestNewHook } from '../../requestUtils';
import { GetCurrentCompany } from '../../customer-context/customer-context';
import ActiveUsersGrid from '../active-users-grid/active-users-grid';
import { IActiveUser } from '../../_models/active-user';
import ActiveUsersGridSkeleton from '../active-users-grid/active-users-grid-skeleton';
import PageTitle from '../../page-title/page-title';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ActiveUsersProps { }

export function ActiveUsers(props: ActiveUsersProps) {
  const { t } = useTranslation();
  const currentCompany = GetCurrentCompany();
  const [isGroup, setIsGroup] = useState<boolean>(false);
  const companyNumber = currentCompany ? currentCompany.number : "";
  const url = currentCompany ? `Licenses/activeUsers/${companyNumber}/forGroup/${isGroup}` : "Licenses/activeUsers/";

  const { data: activeUsers, getData, isLoading }: { data: IActiveUser[], getData: () => void, isLoading: boolean } = useGetRequestNewHook(url, undefined, [currentCompany, isGroup]);
  const handleIsGroupToggle = () => setIsGroup(!isGroup);

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.activeUsers")} />
            {!activeUsers ?
              <ActiveUsersGridSkeleton /> :
              <ActiveUsersGrid
                activeUsers={activeUsers}
                isLoading={isLoading}
                getData={getData}
                onIsGroupChange={handleIsGroupToggle}
                isGroup={isGroup}
              />}
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default ActiveUsers;